import React from 'react';

import { UitkLoader } from 'uitk-react-loader';

import Layout from 'src/components/common/theme/Layout';

interface PageLoaderProps {
  exClass?: string;
  sectionLoader?: boolean;
  isDarkBackground?: boolean;
}

const PageLoader = (props: PageLoaderProps) => {
  const {
    exClass,
    sectionLoader,
    isDarkBackground = false
  } = props
  return (
    <Layout
      HtmlTag="div"
      className={`${sectionLoader ? 'section-loader-container' : 'page-loader-container'} ${exClass || ''}`}          
    >
       <UitkLoader isDarkBackground={isDarkBackground}/>
    </Layout>    
  );
};

export default PageLoader;
